import { OkrService } from './../okr/okr.service';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';

import { DashboardPage } from './dashboard.page';
import { PipesModule } from '../shared/pipes/pipes.module';
import { AssessmentProcessComponent } from './assessment-process/assessment-process.component';
import { DashboardService } from './dashboard.service';
import { DashboardGoalsProgressPage } from './goals-progress/goals-progress.page';
import { UtilService } from '../shared/services/util.service';
import { ViewGoalsModule } from './goals-progress/view-goals/view-goals.module';
import { OkrProgressComponent } from './okr-progress/okr-progress.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { OkrProgressModelModule } from './okr-progress/okr-progress-model/okr-progress-model.module';
import { FeedbackStatusComponent } from './feedback-status/feedback-status.component';
import { CorePrinciplesComponent } from './core-principles/core-principles.component';
import { SelectCycleModule } from '../shared/modals/select-cycle/select-cycle.module';

const routes: Routes = [{
  path: '',
  component: DashboardPage
}];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes),
    PipesModule,
    ViewGoalsModule,
    SelectCycleModule,
    MatExpansionModule,
    MatFormFieldModule,
    OkrProgressModelModule,
    MatTooltipModule,
  ],
  declarations: [
    DashboardPage,
    AssessmentProcessComponent,
    DashboardGoalsProgressPage,
    OkrProgressComponent,
    FeedbackStatusComponent,
    CorePrinciplesComponent
  ],
  providers: [
    DashboardService,
    UtilService,
    OkrService
  ]
})
export class DashboardPageModule { }
